var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mb-base vx-col w-full md:w-1/2",attrs:{"title":_vm.settings.containerLabel}},[_c('div',{staticClass:"mt-5"},[_c('chartjs-component-bar-chart',{attrs:{"height":250,"data":_vm.data,"options":_vm.options}})],1),_c('template',{slot:"codeContainer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }